import type { FindingsBulkFilter } from '../../clients/testerClient';
import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';

export const FINDINGS_COUNT_QUERY_KEY = 'findings-count-by-target';

const toIso = (value: Date | undefined): string | undefined =>
  value instanceof Date ? value.toISOString() : undefined;

export const serializeFindingsBulkFilterForCountQueryKey = (
  filter: FindingsBulkFilter,
) => ({
  endpointId: filter.endpointId ?? null,
  searchTerm: filter.searchTerm ?? null,
  severity: filter.severity ?? null,
  status: filter.status ?? null,
  category: filter.category ?? null,
  isPublished: filter.isPublished ?? null,
  wasAutoPublished: filter.wasAutoPublished ?? null,
  hasPrevention: filter.hasPrevention ?? null,
  hasPendingSeverityChangeRequest:
    filter.hasPendingSeverityChangeRequest ?? null,
  createdStartDate: toIso(filter.createdStartDate),
  createdEndDate: toIso(filter.createdEndDate),
  discoveryStartDate: toIso(filter.discoveryStartDate),
  discoveryEndDate: toIso(filter.discoveryEndDate),
  lifecycleState: filter.lifecycleState ?? null,
});

export const getFindingsMatchingCountQueryKey = ({
  targetId,
  targetType,
  filter,
}: {
  targetId: string;
  targetType: TargetTypeType;
  filter: FindingsBulkFilter;
}) =>
  [
    FINDINGS_COUNT_QUERY_KEY,
    'matching',
    targetId,
    targetType,
    serializeFindingsBulkFilterForCountQueryKey(filter),
  ] as const;

export const getFindingsHeaderTotalCountQueryKey = ({
  targetId,
  targetType,
  filter,
}: {
  targetId: string;
  targetType: TargetTypeType;
  filter: FindingsBulkFilter;
}) =>
  [
    FINDINGS_COUNT_QUERY_KEY,
    'total',
    targetId,
    targetType,
    serializeFindingsBulkFilterForCountQueryKey(filter),
  ] as const;
